import Button from 'components/button';
import { SITE_URL } from 'lib/constants';
import styles from './styles.module.scss';

type ShareItemContainerProps = {
  image: string;
  info: string;
  url: string;
  shareLabel: string;
  copyLabel?: string;
};

const ShareItemContainer: React.FC<ShareItemContainerProps> = (props) => {
  const { image, info, copyLabel = 'Скопировать ссылку', shareLabel, url } = props;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
  };

  const handleShare = async () => {
    try {
      await navigator.share({ url });
    } catch (error) {}
  };

  return (
    <div className={styles.container}>
      <div className={styles.infoContainer}>
        <div className={styles.image}>
          <img alt='' src={image} />
        </div>
        <div className={styles.info}>
          <div className={styles.row}>{info}</div>
          <div className={styles.subRow}>{SITE_URL}</div>
        </div>
      </div>

      <Button label={copyLabel} variant='gray' onClick={handleCopyLink} />
      <Button label={shareLabel} onClick={handleShare} />
    </div>
  );
};

export default ShareItemContainer;
